import React from 'react';
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from '@material-ui/core/styles';
import Button from '../components/Button';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';

const backgroundImage =
  '/background.svg';

const styles = (theme: Theme) =>
  createStyles({
    background: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundColor: '#7fc7d9', // Average color of the background image.
      backgroundPosition: 'center',
    },
    button: {
      // minWidth: 200,
    },
    h5: {
      marginBottom: theme.spacing(4),
      marginTop: theme.spacing(4),
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(10),
      },
    },
    more: {
      marginTop: theme.spacing(2),
    },
  });

function ProductHero(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <ProductHeroLayout backgroundClassName={classes.background}>
      <Typography color="inherit" align="left" variant="h2">
          <p>Versatile Data Annotation </p>
          <p>Platform for AI</p>
      </Typography>
      {/* <Typography
        color="inherit"
        align="center"
        variant="h5"
        className={classes.h5}
      >
      </Typography> */}
      <div>
      <Button
        color="secondary"
        variant="contained"
        // size="large"
        // className={classes.button}
        component="a"
        href="https://github.com/Crowdaq/crowdaq-doc/blob/master/docs/requester/get-started.md"
        target="_blank"
      >
        Get Started
      </Button>
      </div>
      

      <Typography variant="body2" color="inherit" className={classes.more}>
          While Crowdaq is actively serving, this website is currently under construction.
      </Typography>
    </ProductHeroLayout>
  );
}

export default withStyles(styles)(ProductHero);
